import { useEffect, useState } from "react";

/**
 * `value`, but only once it has stood still for `delayMs`.
 *
 * The register's search is part of its query key; without this, „Beispiel"
 * typed at speed is eight requests for seven prefixes nobody wanted (design
 * §8.1: 250 ms). The state is set from the timer, never synchronously inside
 * the effect (`react-hooks/set-state-in-effect`).
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = window.setTimeout(() => setSettled(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);
  return settled;
}
